import * as actions from './actionsTypes'
import * as useLocalStorage from '../services/useLocalStorage'


export default function reducer(state=[], action) {
    switch(action.type) {
        case (actions.USER_LOGGED_IN):
            console.log("Setting stuff up:")
            console.log(action.payload.userData);
            console.log(action.payload.userData.name);
            console.log(action.payload.userData.token);
            console.log(action.payload.userData.username);
            console.log(action.payload.userData.id);
            useLocalStorage.setItem("token",action.payload.userData.token);
            useLocalStorage.setItem("user", action.payload.userData.name);
            useLocalStorage.setItem("username", action.payload.userData.username);
            useLocalStorage.setItem("id", action.payload.userData.id);
            useLocalStorage.setItem("adminDaily", action.payload.userData.adminDaily);
            useLocalStorage.setItem("adminNumeration", action.payload.userData.adminNumeration);
            useLocalStorage.setItem("adminAll", action.payload.userData.adminAll);
            useLocalStorage.setItem("adminDailyData", action.payload.userData.adminDailyData);
            useLocalStorage.setItem("stat", action.payload.userData.stat);
            useLocalStorage.setItem("allStat", action.payload.userData.allStat);
            useLocalStorage.setItem("edit0600", action.payload.userData.edit0600);
            useLocalStorage.setItem("edit0800", action.payload.userData.edit0800);
            


            return action.payload;
        case (actions.USER_LOGGED_OUT):
            useLocalStorage.clearLocalStorate()
            sessionStorage.clear()
            return [];
        case (actions.KORISNIK_SELECTED):
            sessionStorage.setItem("korisnik", action.payload.korisnik.korisnik)
            return {...state, korisnik: {value: action.payload.korisnik.korisnik}};
        case (actions.NET_SET):
            console.log("Gotten reducer");
            console.log(action.payload.TKC);
            sessionStorage.setItem("tkc",action.payload.TKC);
            useLocalStorage.setItem("tkc",JSON.stringify(action.payload.TKC));
            return {...state, TKC:{value: action.payload.TKC}};        
        case (actions.AUTO_MODAL_OPENED):
            return {...state, autoModal: {open: true}};
        case (actions.AUTO_MODAL_CLOSED):
            return {...state, autoModal: {open: false}};
        case (actions.MENU_OPENED):
            return {...state, menu:{open:true}};
        case (actions.MENU_CLOSED):
            return {...state, menu:{open:false}};
        case (actions.IS_LOADING):
            return {...state, loader:{isLoading: false}};
        case (actions.IS_NOT_LOADING):
            return {...state, loader:{isLoading: true}};
        case (actions.TOGGLE_VARIABLE):
            return {...state, togglingVariable: {value: action.payload.value}};
        default:
            return state
    }
    
}